import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import CustomisedButton from '../../components/button/button';
import { IGetCustomerContractResponse } from '../../models/customerContract.model';
import { changeRouteType } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { GetCustomerContract } from '../../services/customerContract.service';
import { IContract } from './IContract';
import './viewContract.css';
import ViewContractSkeleton from './viewContractSkeleton';

const ViewContract = ({ setState, referenceKey }: IContract) => {
    const [contract, setContent] = useState<IGetCustomerContractResponse>();
    const [errorRaised, setErrorRaised] = useState(false)
    const dispatch = useDispatch();
    const { mutate: GetCustomerContractMutate, isLoading } = useMutation(
        GetCustomerContract,
        {
            onSuccess: (data: IGetCustomerContractResponse) => {
                if (data && data.contractHtml) {
                    setContent(data);
                } else {
                    setErrorRaised(true)
                }
            },
            onError: () => { },
        }
    );

    useEffect(() => {
        GetCustomerContractMutate({
            referenceKey: referenceKey!,
        });
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        dispatch(setHeaderTitle({ header: 'قرارداد', color: 'var(--input-bg-color)', parentRoute: '', }));

    }, []);

    const handleContinue = () => {
        dispatch(changeRouteType({ routeType: 'child' }));
        setState!('signContract');
    }

    if (isLoading) return <ViewContractSkeleton />;

    return (
        <div className='container-height-drawer'>
            <div className="content-container">
                <div className='drawer-content'>
                    {/* contract section */}
                    <div className="contract-height overflow-y-auto p-4 mt-6 bg-white border-2 border-dashed border-[#D7DBEC] rounded-[5px]">
                        <div
                            className="viewContract-contract"
                            dangerouslySetInnerHTML={{ __html: contract?.contractHtml! }}
                        />
                    </div>
                </div>
                {/* btns for sign and download contract */}
                <div className="py-5" >
                    {contract?.hasBankContract && (
                        <div>
                            <Link
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginY: '1rem',
                                    width: '100%',
                                    border: "1px solid #BBA57A",
                                    borderRadius: "5px"
                                }}
                                href={contract?.bankContractDownloadUrl}
                                download="قرارداد.pdf"
                                underline="none"
                                target="_blank"
                                rel="noopener"
                            >
                                <FileDownloadOutlinedIcon
                                    sx={{
                                        color: '#BBA57A',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                    }}
                                />
                                <Button
                                    sx={{
                                        color: '#BBA57A',
                                        fontSize: '1rem',
                                        fontWeight: 'bold',
                                        paddingRight: '.1em',
                                    }}
                                >
                                    {contract.bankContractTitle}
                                </Button>
                            </Link>
                        </div>
                    )}
                    <div>
                        <CustomisedButton
                            title="ادامه"
                            disable={errorRaised}
                            onClick={handleContinue}
                            type="button"
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ViewContract;
